<template>
  <!-- MODALE SUPPRESSION -->
  <b-modal
    title-class="modal__title"
    id="modal-eolienne-delete"
    v-if="currentEolienne"
    size="md"
    :title="'Supprimer l\'éolienne'"
    @ok="deleleAerogenerateur"
  >
    <p class="mt-3 modal-delete__text">
      Souhaitez-vous supprimer l'éolienne {{ currentEolienne.id }} ?
    </p>
    <template #footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button variant="danger" title="Valider la suppression" @click="ok()">
        Supprimer
      </b-button>
      <b-button
        variant="default"
        title="Annuler la suppression"
        @click="cancel()"
      >
        Annuler
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import {BModal, BButton} from "bootstrap-vue-next";

import {useReactiveStoreGetters} from "@/composables/useStore";
import {aerogenerateurService} from "@/service/aerogenerateur.service";
import {ref, watch} from "vue";

// Props
const {eolienne, addNotification} =defineProps(["eolienne", "addNotification"]);

// Data
const currentEolienne = ref(eolienne)

// Watch for changes in the prop
watch(() => eolienne, (newValue) => {
  currentEolienne.value = newValue
})

// Methods
const deleleAerogenerateur = () => {
  aerogenerateurService
    .deleteAerogenerateur(eolienne.id)
    .then(response => {
      const httpMethod = "DELETE";
      addNotification(response, httpMethod);
    })
    .catch(err => {
      console.log(err);
    });
};

</script>
<style lang="scss">
.modal-delete {
  &__text {
    margin-left: 2px;
  }
}
</style>
